import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ILab } from '../../../app/models/labs/lab';
import { LabService } from '../../../app/services/lab-service';
import { ToastrService } from 'ngx-toastr';
import { DialogEditLabComponent} from './edit/edit-lab-dialog'
import { DialogDeleteLabComponent } from './delete/delete-lab-dialog';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'app-labs',
  templateUrl: './labs.component.html',
  styleUrls: ['./labs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabsComponent implements  OnInit  {
  processing: boolean = false;
  loading: boolean = false;
  pageSize = 50;
  labs: ILab[] = [];

  displayedColumns: string[] = ['labName', 'active', 'orelap', 'labAddress1','labEmail','labPhone','actions'];
  dataSource = new MatTableDataSource<ILab>(this.labs);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  constructor(public dialog: MatDialog, 
              public oregonWellDataService : OregonWellDataService,
              public authService: AuthService,
              private labService: LabService,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.loadLabs();
  }

  loadLabs() {
    this.loading = true;
    this.labService.getLabs().subscribe(
      result => {
        this.labs = result;
        this.loading = false;
      },
      error => {
        this.toastr.error(error.message);
        this.loading = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<ILab>(this.labs);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  editLab(labDetailsId: number) {
    const dialogRef = this.dialog.open(DialogEditLabComponent, {
      width: '90%',
      data: labDetailsId
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadLabs();
    });
  }

  deleteLab(labDetailsId: number) { 
    const dialogRef = this.dialog.open(DialogDeleteLabComponent, {
      width: '90%',
      data: labDetailsId
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadLabs();
    });    
  }
}